import { useState, useEffect } from "react";
import Header from "./Header"
import Footer from "./Footer"
import LoginDialog from "./LoginDialog";
import { Outlet, ScrollRestoration } from "react-router-dom"
import ChangeLanguageFunctions from "@/contexts/changeLanguageContext";
import intl from "react-intl-universal";
import styles from "./index.module.scss"
import SVG from "react-inlinesvg";
import roabot from "@/assets/images/service.png"
import { useDispatch } from "react-redux";
import { setIsChartOpen } from "@/store/modules/user";
import RoabotChart from './Roabot'
import classNames from "classnames";
const locales = {
	"en-US": require("@/locales/en-US.json"),
	"zh-CN": require("@/locales/zh-CN.json"),
};

const Layout = () => {
	const [routerKey, setRouterKey] = useState(Date.now())
	const [isShow, setIsShow] = useState(false)
	const dispatch = useDispatch()
	const handleScroll = () => {
		let height = document.documentElement.scrollTop || document.body.scrollTop
		if (height > 700) {
			setIsShow(true)
		} else {
			setIsShow(false)
		}
	}

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);
	const changeLang = (val) => {
		localStorage.setItem('lang', val)
		setRouterKey(Date.now());
		intl.init({
			currentLocale: val,
			locales,
		});
	}

	const backTop = () => {
		let duration = 300
		const startY = window.pageYOffset;
		const startTime = performance.now();

		function scrollStep(timestamp) {
			const elapsed = timestamp - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const currentY = startY - startY * progress;
			window.scrollTo(0, currentY);

			if (elapsed < duration) {
				requestAnimationFrame(scrollStep);
			}
		}

		requestAnimationFrame(scrollStep);
	}

	// const backTop = () => {
	// 	const c = document.documentElement.scrollTop || document.body.scrollTop;
	// 	if (c > 0) {
	// 		window.requestAnimationFrame(backTop);
	// 		window.scrollTo(0, c - c / 40);
	// 	}
	// }
	const [showText, setText] = useState(false)
	const hoverInRoabot = () => {
		setText(true)
	}
	const hoverOutRoabot = () => {
		setText(false)
	}
	const weChart = () => {
		dispatch(setIsChartOpen(true))
	}
	return <ChangeLanguageFunctions.Provider value={{ changeLang }}>
		<div key={routerKey}>
			<Header />
			<LoginDialog />
			{/* <RoabotChart /> */}
			{isShow && <div className={styles.backTop} onClick={backTop}>
				<SVG src={`${process.env.PUBLIC_URL}/svg/back.svg`} width={40} height={27}></SVG>
			</div>}

			{/* <div onMouseLeave={hoverOutRoabot} onMouseEnter={hoverInRoabot} className={classNames('flex_box','align_center','flex_center',styles.roabotBox)} onClick={weChart}>
				{showText?<span>智能助手</span>:<img src={roabot} />}
			</div> */}
			<ScrollRestoration /> {/* 关键：添加滚动恢复组件 */}
			<Outlet />
			<Footer />
		</div>
	</ChangeLanguageFunctions.Provider>
}
export default Layout